import { useTranslation } from 'react-i18next';

const NOTE_COUNT = 3;

export default function ImportantNotes() {
  const { t } = useTranslation();
  return (
    <section className="relative py-12 md:py-16 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center">
          <h3 className="font-heading text-[17px] text-foreground-800 tracking-[0.06em] mb-6">
            {t('seminar.notes.title')}
          </h3>
          <ul className="space-y-3 text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed max-w-lg mx-auto">
            {Array.from({ length: NOTE_COUNT }, (_, idx) => (
              <li key={idx}>&#8226; {t(`seminar.notes.${idx}`)}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
